import { fillAdminCourseDetails } from "../../Pages/AdminCourseManagement/Fills";
import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";

export var removeTutorFromCourse = function(userId, courseId, btn=false, async=true){

        const url = '/course/' + courseId.toString() + '/tutor/' + userId.toString() + '/remove'

        const success = function(data){
            fillAdminCourseDetails(courseId); // Hier könnte man noch offenstehende Freischaltungen vermerken
            successToast('Tutor/-in erfolgreich vom Kurs entfernt', 'Erfolg', 5000, true);
        }

        return ajaxRequest(url, success, {}, btn, async);
  }